import axios from "./axiosinstance";

const StateApi = {
  getStates: () => axios.get("/states/states"),
  getDistrictsByState: (id) => axios.get(`/states/districts/${id}`),
};

export default StateApi;